import PropTypes from 'prop-types';
import classNames from 'classnames';
import { makeStyles } from '@material-ui/core';
import TextBoxWithTooltip from '../textBoxWithTooltip';
import CompletedInfo from '../attributeInfoBar/completedInfo';

const useStyles = makeStyles(({ palette: { primary }, spacing }) => ({
  root: {
    boxSizing: 'border-box',
    backgroundColor: primary.blue8,
    border: `1px solid ${primary.blue5}`,
    borderRadius: 4,
    display: 'flex',
    alignItems: 'center',
    minHeight: 48,
    padding: spacing(0, 6),
    width: '100%',
  },
  title: {
    marginRight: spacing(2),
  },
}));

const QuestionnaireInfoBar = ({
  className = null,
  translations,
  name = '',
  finishedCount = 0,
  reviewersCount = 0,
  hasCompletedCount = false,
}) => {
  const classes = useStyles();

  return (
    <div className={classNames(classes.root, className)}>
      <TextBoxWithTooltip className={classes.title} variant="h5" text={name} />
      {hasCompletedCount && (
        <CompletedInfo
          label={translations.completed}
          allReviewers={reviewersCount}
          finishedCount={finishedCount}
        />
      )}
    </div>
  );
};

QuestionnaireInfoBar.propTypes = {
  className: PropTypes.string,
  translations: PropTypes.object.isRequired,
  name: PropTypes.string,
  finishedCount: PropTypes.number,
  reviewersCount: PropTypes.number,
  hasCompletedCount: PropTypes.bool,
};

export default QuestionnaireInfoBar;
